module.exports = __webpack_public_path__ + "img/Icon-FB1.1c8efaf6.png";